<template>
    <div>
        <el-skeleton v-if="dataLoading" :rows="8" animated />
        <div v-else id="radar-chart"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { pointDetail } from "@/api/statistic"

export default {
    data: () => ({
        radarData: {
            integral_give: 0,
            integral_expenditure: 0,
            integral_withdrawal: 0
        },
        dataLoading: false
    }),
    props: {
        time: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async getData() {
            this.dataLoading = true
            try {
                const { data } = await pointDetail(this.time)
                console.log(data);
                this.radarData = data
                return Promise.resolve('yayy')
            } catch {
                return Promise.reject('noo')
            } finally {
                this.dataLoading = false
            }
        },
        initChart() {
            const { integral_give, integral_expenditure, integral_withdrawal } = this.radarData
            let max_value = Math.max(integral_give, integral_expenditure, integral_withdrawal);

            const radarChart = echarts.init(document.querySelector("#radar-chart"))
            radarChart.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                radar: {
                    // shape: 'circle',
                    indicator: [
                        { name: '已送出积分数', max: max_value },
                        { name: '已核销积分数', max: max_value },
                        { name: '已提现积分数', max: max_value },
                    ],

                },
                series: [
                    {
                        type: 'radar',
                        top: '100%',
                        tooltip: {
                            trigger: 'item'
                        },
                        data: [
                            {
                                value: [integral_give, integral_expenditure, integral_withdrawal],
                                name: 'Allocated Budget'
                            }
                        ]
                    }
                ]
            })
        }
    },
    watch: {
        time: {
            handler() {
                this.getData().then(() => {
                    this.initChart()
                })
            },
            deep: true
        }
    },
    mounted() {
        this.getData().then(() => {
            this.initChart()
        })
    },
}
</script>

<style lang="scss" scoped>
#radar-chart {
    width: 100%;
    min-height: 300px;
    padding-top: 50px;
}
</style>